export const EventDetailsContent = {
  // Section headings
  eventInfo: 'Event Info',
  remindMe: 'Remind Me',
  rsvp: 'RSVP',
  addToCalendar: 'Add to Calendar',
  eventLink: {
    label: 'Join Online',
    openLink: 'Open Link',
  },

  // Admin RSVP summary card
  adminRsvpCard: {
    countLabel: 'Attending',
    viewListCta: 'View RSVP List',
    ariaLabel: 'View RSVP list for this event',
  },

  // Alert messages
  alertDeadlinePassed: {
    title: 'Oh no!',
    message: 'Unfortunately, the RSVP deadline has passed for this event.',
  },
  alertCapacityReached: {
    title: 'Oh no!',
    message:
      'Unfortunately, this event has reached capacity. Please check back periodically in case space opens up.',
  },

  // RSVP button labels
  rsvpGoing: 'Going',
  rsvpNotGoing: 'Not Going',
  rsvpCancel: 'Cancel RSVP',
  rsvpAttendedNote:
    'Your attendance has been recorded. Contact an admin if this looks wrong.',

  // RSVP confirmation modals
  confirmRsvp: {
    title: 'Confirm RSVP?',
    message: 'Are you sure you want to confirm your attendance for this event?',
    cancelButton: 'Cancel',
    confirmButton: 'Will attend',
  },
  cancelRsvp: {
    title: 'Cancel RSVP?',
    message: 'Are you sure you want to cancel your attendance for this event?',
    cancelButton: 'Cancel',
    confirmButton: "I won't attend",
  },

  // Remind Me multi-select options
  // Values match ReminderTimeOption enum in notifications.types.ts
  remindMeOptions: [
    { value: 'remind_1_hr', label: '1 hour before' },
    { value: 'remind_1_day', label: '1 day before' },
    { value: 'remind_3_days', label: '3 days before' },
  ],

  // Edit button
  editButton: {
    ariaLabel: 'Edit event',
  },

  // Series banner and drawer
  seriesBanner: {
    label: 'Part of a series',
    ariaLabel: 'View all events in series',
  },
  seriesDrawer: {
    title: 'All Events in Series',
  },
};
